(function() {
    'use strict';

    angular
        .module('skillsApp')
        .factory('dataService', dataService);

    function dataService(config, $http, $q, $log, tokenService, cgbusyService, notifyingService, logger) {

        var service = {

            changeClusterActionCluster: changeClusterActionCluster,
            createSkills: createSkills,
            createSkillsForFunctions: createSkillsForFunctions,

            deleteAdministrator: deleteAdministrator,
            deleteAssessor: deleteAssessor,
            deleteCluster: deleteCluster,
            deleteClusterAction: deleteClusterAction,
            deleteExaminer: deleteExaminer,
            deleteExaminerFromUserQualityActivity: deleteExaminerFromUserQualityActivity,
            deleteExemption: deleteExemption,
            deleteMark: deleteMark,
            deleteReportViewer: deleteReportViewer,
            deleteSkill: deleteSkill,
            deleteUserQuality: deleteUserQuality,

            exportExaminerAssignments: exportExaminerAssignments,

            getAllClusters: getAllClusters,
            getAsset: getAsset,
            getClusterAction: getClusterAction,
            getClusterActions: getClusterActions,
            getClusterTypes: getClusterTypes,
            getEmployeeActivities: getEmployeeActivities,
            getExaminerActivities: getExaminerActivities,
            getExaminerClusterActions: getExaminerClusterActions,
            getExaminerSkillActivitySettings: getExaminerSkillActivitySettings,
            getIndividualUserQualitiesForAdmin: getIndividualUserQualitiesForAdmin,
            getMyUserQualities: getMyUserQualities,
            getSettings: getSettings,
            getSettingsForAdmin: getSettingsForAdmin,
            getSkill: getSkill,
            getSkills: getSkills,
            getUserQuality: getUserQuality,
            getUserQualities: getUserQualities,
            getUserQualitiesForReport: getUserQualitiesForReport,

            importExaminerAssignments: importExaminerAssignments,

            saveAdministrator: saveAdministrator, 
            saveAssessor: saveAssessor,
            saveCluster: saveCluster,
            saveClusterAction: saveClusterAction,
            saveExemption: saveExemption,
            saveMark: saveMark,
            saveNotNecessary: saveNotNecessary,
            saveReportViewer: saveReportViewer,
            saveSetting: saveSetting,
            saveSkill: saveSkill,
            
            searchCategoriesAndSkills: searchCategoriesAndSkills,
            searchExaminerUsers: searchExaminerUsers,
            searchSkills: searchSkills,
            searchUserQualitiesUsers: searchUserQualitiesUsers,

            setExaminerForUserQualityActivity: setExaminerForUserQualityActivity,
            setExaminerSkillActivitySettings: setExaminerSkillActivitySettings
        };

        return service;
        
        // private methods
        function _http(req, skipBusy) {

            if (skipBusy === true) {

                return tokenService.getToken()
                    .then(() => { return $http(req); })
                    .catch(response => {
                        $log.error('Error:', req, response);
                        return $q.reject(response);
                    });
            } else {
                return cgbusyService.blockUI( // for now this is the best way to use cgbusy: just use it in one place
                    tokenService.getToken() // get a token
                        .then(() => { return $http(req); }) // execute the actual request
                        .catch(response => {
                            $log.error('Error:', req, response);
                            return $q.reject(response);
                        }));
            }
        }

        // public methods

        function changeClusterActionCluster(clusterActionId, clusterId) {
            var req = {
                url: config.baseUrl + '/api/6.0/clusteraction/cluster/' + config.portalIdentifier,
                method: 'PATCH',
                params: {
                    clusterActionId: clusterActionId,
                    clusterId: clusterId
                }
            };

            return _http(req).then(result => {
                    notifyingService.notify('clusteraction-updated', result);
                    return result;
                });
        }

        function createSkills(newSkill, changeVector, assignments) {
            var req = {
                url: config.baseUrl + '/api/6.0/skill/' + config.portalIdentifier,
                method: 'POST',
                data: {
                    skill: newSkill,
                    changeVector: changeVector,
                    assignments: assignments,
                    enableActivityOrdering: true
                } 
            };

            return _http(req).then(result => {
                notifyingService.notify('skills-created', result);
                return result;
            });
        }

        function createSkillsForFunctions(actionId, functions) {
            var req = {
                url: config.baseUrl + '/api/6.0/skill/functions/' + config.portalIdentifier,
                method: 'POST',
                data: {
                    actionId: actionId,
                    functions: functions
                }
            };

            return _http(req).then(result => {
                notifyingService.notify('skills-created', result);
                return result;
            });
        }

        function deleteAdministrator(idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/administrator/' + config.portalIdentifier,
                method: 'DELETE',
                params: { idString: idString }
            };

            return _http(req).then(response => { return response.data; });
        }

        function deleteAssessor(idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/assessor/' + config.portalIdentifier,
                method: 'DELETE',
                params: { idString: idString }
            };

            return _http(req).then(response => { return response.data; });
        }

        function deleteCluster(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/cluster/' + config.portalIdentifier,
                method: 'DELETE',
                params: { id: id }
            };

            return _http(req).then(response => {
                notifyingService.notify('cluster-deleted', id);
                return response.data;
            });
        }

        function deleteClusterAction(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/clusteraction/' + config.portalIdentifier,
                method: 'DELETE',
                params: { id: id }
            };

            return _http(req).then(response => {
                notifyingService.notify('clusteraction-deleted', id);
                return response.data;
            });
        }

        function deleteExaminer(idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/' + config.portalIdentifier,
                method: 'DELETE',
                params: { idString: idString }
            };

            return _http(req).then(response => { return response.data; });
        }

        function deleteExaminerFromUserQualityActivity(userQualityId, activityId) {
            var req = {
                url: config.baseUrl + '/api/6.0/userquality/activity-examiner/' + config.portalIdentifier,
                method: 'DELETE',
                params: {
                    userQualityId: userQualityId,
                    activityId: activityId
                }
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data);
                return response.data;
            });
        }

        function deleteExemption(userQualityId) {
            var req = {
                url: config.baseUrl + '/api/6.0/exemption/' + config.portalIdentifier,
                method: 'DELETE',
                params: { userQualityId: userQualityId }
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data);
                return response.data;
            });
        }

        function deleteMark(userQualityId, markId) {
            var req = {
                url: config.baseUrl + '/api/6.0/mark/' + config.portalIdentifier,
                method: 'DELETE',
                params: {
                    userQualityId: userQualityId,
                    markId: markId
                }
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data);
                return response.data;
            });
        }

        function deleteReportViewer(idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/reportviewer/' + config.portalIdentifier,
                method: 'DELETE',
                params: { idString: idString }
            };

            return _http(req).then(response => { return response.data; });
        }
        
        function deleteSkill(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/skill/' + config.portalIdentifier,
                method: 'DELETE',
                params: { id: id }
            };

            return _http(req).then(response => {
                notifyingService.notify('skill-deleted', id);
                return response.data;
            });
        }

        function deleteUserQuality(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/userquality/' + config.portalIdentifier,
                method: 'DELETE',
                params: { id: id }
            };

            return _http(req).then(response => { return response.data; });
        }

        function exportExaminerAssignments(examiner, examiners, removeExistingAssignments) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/export-assignments/' + config.portalIdentifier,
                method: 'POST',
                data: {
                    examiner: examiner,
                    examiners: examiners,
                    removeExistingAssignments: removeExistingAssignments
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getAllClusters() {
            var req = {
                url: config.baseUrl + '/api/6.0/clusters/' + config.portalIdentifier,
                method: 'GET'
            };

            return _http(req).then(response => { return response.data; });
        }

        function getAsset(userQualityId, id) {
            var req = {
                url: config.baseUrl + '/api/6.0/exemption/' + config.portalIdentifier + '/asset',
                params: { userQualityId: userQualityId, id: id },
                method: 'GET',
                responseType: 'arraybuffer'
            };

            return _http(req);
        }

        function getClusterAction(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/clusteraction/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    id: id
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getClusterActions(clusterId) {
            var req = {
                url: config.baseUrl + '/api/6.0/clusteractions/' + config.portalIdentifier,
                method: 'GET',
                params: { clusterId: clusterId }
            };

            return _http(req).then(response => { return response.data; });
        }
        
        function getClusterTypes(type) {
            var clusterTypes = config.settings.clusterTypes;

            if (type === undefined) return clusterTypes;

            var clusterType = null;
            for (var i = 0; i < clusterTypes.length; i++) {
                if (clusterTypes[i].type === type) {
                    clusterType = clusterTypes[i];
                    break;
                }
            }
            return clusterType;
        }

        function getEmployeeActivities(idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/activities/employee/' + config.portalIdentifier,
                method: 'GET',
                params: { idString: idString }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getExaminerActivities() {
            var req = {
                url: config.baseUrl + '/api/6.0/activities/examiner/' + config.portalIdentifier,
                method: 'GET'
            };

            return _http(req).then(response => { return response.data; });
        }

        function getExaminerClusterActions(idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/clusteractions/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    idString: idString
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getExaminerSkillActivitySettings(actionId, idString) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/skill-activity-settings/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    actionId: actionId,
                    idString: idString
                }
            };

            return _http(req).then(response => { return response.data; });
        }
        
        function getIndividualUserQualitiesForAdmin(params) {
            var req = {
                url: config.baseUrl + '/api/6.0/admin/userqualities/individual/' + config.portalIdentifier,
                method: 'GET',
                params: params
            };

            return _http(req).then(response => { return response.data; });
        }

        function getMyUserQualities(params) {
            var req = {
                url: config.baseUrl + '/api/6.0/userqualities/my/' + config.portalIdentifier,
                method: 'GET',
                params: params
            };

            return _http(req).then(response => { return response.data; });
        }
        
        function getSettings() {
            
            var req = {
                url: config.baseUrl + '/api/6.0/settings/' + config.portalIdentifier,
                method: 'GET'
            };
            
            return _http(req);
        }

        function getSettingsForAdmin() {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/admin/' + config.portalIdentifier,
                method: 'GET'
            };

            return _http(req);
        }

        function getSkill(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/skill/' + config.portalIdentifier,
                method: 'GET',
                params: { id: id }
            };

            return _http(req).then(response => { return response.data; });
        }
        
        function getSkills(actionId) {
            var req = {
                url: config.baseUrl + '/api/6.0/skills/' + config.portalIdentifier,
                method: 'GET',
                params: { actionId: actionId }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getUserQuality(id) {
            var req = {
                url: config.baseUrl + '/api/6.0/userquality/' + config.portalIdentifier,
                method: 'GET',
                params: { id: id }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getUserQualities(params) {
            var req = {
                url: config.baseUrl + '/api/6.0/userqualities/' + config.portalIdentifier,
                method: 'GET',
                params: params
            };

            return _http(req).then(response => { return response.data; });
        }

        function getUserQualitiesForReport(params) {
            var req = {
                url: config.baseUrl + '/api/6.0/userqualities/report/' + config.portalIdentifier,
                method: 'GET',
                params: params
            };

            return _http(req).then(response => { return response.data; });
        }

        function importExaminerAssignments(examiner, examiners, removeExistingAssignments) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/import-assignments/' + config.portalIdentifier,
                method: 'POST',
                data: {
                    examiner: examiner,
                    examiners: examiners,
                    removeExistingAssignments: removeExistingAssignments
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function saveAdministrator(identity) {

            var req = {
                url: config.baseUrl + '/api/6.0/settings/administrator/' + config.portalIdentifier,
                data: identity,
                method: 'POST'
            };

            return _http(req).then(response => { return response.data; });
        }
        
        function saveAssessor(identity) {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/assessor/' + config.portalIdentifier,
                data: identity,
                method: 'POST'
            };

            return _http(req).then(response => { return response.data; });
        }

        function saveCluster(cluster) {
            var req = {
                url: config.baseUrl + '/api/6.0/cluster/' + config.portalIdentifier,
                data: cluster,
                method: cluster.id ? 'PUT' : 'POST'
            };

            return _http(req).then(response => {
                notifyingService.notify('cluster-updated', response.data);
                return response.data;
            });
        }

        function saveClusterAction(clusterAction, changeVector, setValidityForAllAssignments = false) {

            var req = {
                url: config.baseUrl + '/api/6.0/clusteraction/' + config.portalIdentifier,
                data: {
                    clusterAction: clusterAction,
                    changeVector: changeVector,
                    enableActivityOrdering: true
                },
                method: clusterAction.id ? 'PUT' : 'POST'
            };

            if (clusterAction.id) {
                req.data.setValidityForAllAssignments = setValidityForAllAssignments;
            } 

            return _http(req)
                .then(response => {
                    if (response.data.item) {
                        notifyingService.notify('clusteraction-updated', response.data.item);
                    }
                    return response.data;
                });
        }
        
        function saveExemption(userQualityId, dateOfExpiry, description, filesToRemove, filesToAdd) {

            var fd = new FormData();
            var d = new Date(dateOfExpiry);

            fd.append('userQualityId', userQualityId);
            fd.append('dateOfExpiry', new Date(d.getFullYear(), d.getMonth(), d.getDate()).toISOString());
            fd.append('description', description ? description : '');

            if (filesToRemove !== undefined && filesToRemove !== null) {
                fd.append('removeAssets', filesToRemove);
            }

            angular.forEach(filesToAdd, function (file) {
                fd.append('file', file);
            });

            var req = {
                url: config.baseUrl + '/api/6.0/exemption/' + config.portalIdentifier,
                data: fd,
                headers: { 'Content-Type': undefined },
                method: 'POST'
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data);
                return response.data;
            });
        }

        function saveMark(userQualityId, groupId, activityId, approvedDate, approved, remark) {

            var req = {
                url: config.baseUrl + '/api/6.0/mark/' + config.portalIdentifier,
                data: {
                    userQualityId: userQualityId,
                    activityId: activityId,
                    approvedDate: approvedDate,
                    approved: approved,
                    remark: remark ? remark : ''
                },
                method: 'POST'
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data.item);
                return response.data.item;
            });
        }
        
        function saveNotNecessary(userQuality, notNecessary) {
            var req = {
                url: config.baseUrl + '/api/6.0/userquality/notnecessary/' + config.portalIdentifier,
                data: {
                    id: userQuality.id,
                    notNecessary: notNecessary
                },
                method: 'PUT'
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data);
                return response.data;
            });
        }

        function saveReportViewer(identity) {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/reportviewer/' + config.portalIdentifier,
                data: identity,
                method: 'POST'
            };

            return _http(req).then(response => { return response.data; });
        }

        function saveSetting(setting, value) {
            var req = {
                url: config.baseUrl + '/api/6.0/settings/' + setting + '/' + config.portalIdentifier,
                params: { value: value },
                method: 'PUT'
            };

            return _http(req).then(response => { return response.data; });
        }

        function saveSkill(skill, changeVector, setValidityForAllAssignments = false) {
            var req = {
                url: config.baseUrl + '/api/6.0/skill/' + config.portalIdentifier,
                data: {
                    skill: skill,
                    changeVector: changeVector,
                    setValidityForAllAssignments: setValidityForAllAssignments,
                    enableActivityOrdering: true
                },
                method: 'PUT'
            };

            return _http(req)
                .then(response => {
                    notifyingService.notify('skill-updated', response.data.item);
                    return response.data;
                });
        }

        function searchCategoriesAndSkills(search) {
            var req = {
                url: config.baseUrl + '/api/6.0/search/categories-and-skills/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    search: search
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function searchExaminerUsers(search) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/users/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    search: search
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function searchSkills(search) {
            var req = {
                url: config.baseUrl + '/api/6.0/search/skills/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    search: search
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function searchUserQualitiesUsers(search) {
            var req = {
                url: config.baseUrl + '/api/6.0/userqualities/users/' + config.portalIdentifier,
                method: 'GET',
                params: {
                    search: search
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function setExaminerForUserQualityActivity(userQualityId, activityId, examinerIdString, examinerName) {
            var req = {
                url: config.baseUrl + '/api/6.0/userquality/activity-examiner/' + config.portalIdentifier,
                data: {
                    userQualityId: userQualityId,
                    activityId: activityId,
                    examinerIdString: examinerIdString,
                    examinerName: examinerName
                },
                method: 'POST'
            };

            return _http(req).then(response => {
                notifyingService.notify('userquality-updated', response.data);
                return response.data;
            });
        }

        function setExaminerSkillActivitySettings(actionId, idString, settings) {
            var req = {
                url: config.baseUrl + '/api/6.0/examiner/skill-activity-settings/' + config.portalIdentifier,
                method: 'POST',
                data: {
                    actionId: actionId,
                    idString: idString,
                    settings: settings
                }
            };
            
            return _http(req, true).then(response => { return response.data; });
        }
    }
})();
